import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { UserId } from 'features/users/types';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { selectPhoneUserById } from 'features/sip/sipSlice';
import { unmuteRemotePhoneUserRequested } from 'features/sip/actions';

const UnmuteRemotePhoneAudioConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const userId = modalData.userId as UserId;
  const user = useAppSelector((state) => selectPhoneUserById(state, userId));

  const { hasPermissions } = usePermissions();

  const canManagePhoneUsers = hasPermissions(PermissionTypes.managePhoneUsers);

  const shouldClose = !canManagePhoneUsers || !user;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('unmuteRemotePhoneAudioConfirmation'));
    }
  }, [shouldClose, dispatch]);

  if (!user) {
    return null;
  }

  const handleCancel = () => {
    dispatch(closeModal('unmuteRemotePhoneAudioConfirmation'));
  };

  const handleOk = () => {
    dispatch(
      unmuteRemotePhoneUserRequested({
        id: user.id,
      })
    );
    dispatch(closeModal('unmuteRemotePhoneAudioConfirmation'));
  };

  const username = user.name || user.phoneNumber;

  return (
    <ConfirmationDialog
      open={!shouldClose}
      title={t('sip.unmute_remote_phone_audio_confirm.title', { username })}
      description={t('sip.unmute_remote_phone_audio_confirm.description', { username })}
      cancelText={t('sip.unmute_remote_phone_audio_confirm.btn_cancel_label')}
      okText={t('sip.unmute_remote_phone_audio_confirm.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default UnmuteRemotePhoneAudioConfirmation;
